import { colors } from '../../colors';
import type { InputSize, InputStyleProps, InputVariant } from './types';

export const getInputSizeStyles = (size: InputSize): string => {
  switch (size) {
    case 'small':
      return `
        padding: 2px 8px !important;
        font-size: 14px;
        line-height: 20px;
      `;
    case 'large':
      return `
        padding: 8px 18px !important;
        font-size: 18px;
        line-height: 28px;
      `;
    case 'medium':
    default:
      return `
        padding: 5px 12px !important;
        font-size: 16px;
        line-height: 24px;
      `;
  }
};

export const getInputVariantStyles = (
  variant: InputVariant,
  error: boolean,
  styleProps?: InputStyleProps
): string => {
  const {
    backgroundColor,
    focusBackgroundColor,
    errorBackgroundColor,
    borderColor,
    focusBorderColor,
    errorBorderColor,
    color,
    placeholderColor,
  } = styleProps ?? {};

  const getErrorStyles = () => {
    if (!error) return '';
    return `
      border-color: ${errorBorderColor ?? colors.error} !important;
      background-color: ${errorBackgroundColor ?? backgroundColor ?? 'inherit'};
    `;
  };

  switch (variant) {
    case 'outline':
      return `
        background-color: ${backgroundColor ?? colors.white};
        border-color: ${borderColor ?? colors.gray[300]} !important;
        color: ${color ?? 'inherit'};

        &:focus {
          border-color: ${focusBorderColor ?? colors.primary[300]} !important;
          background-color: ${focusBackgroundColor ?? backgroundColor ?? colors.white};
        }

        &::placeholder {
          color: ${placeholderColor ?? colors.gray[400]};
        }

        ${getErrorStyles()}
      `;
    case 'filled':
      return `
        background-color: ${backgroundColor ?? colors.gray[100]};
        border-color: ${borderColor ?? colors.transparent} !important;
        color: ${color ?? 'inherit'};

        &:focus {
          border-color: ${focusBorderColor ?? colors.primary[300]};
          background-color: ${focusBackgroundColor ?? colors.white};
        }

        &::placeholder {
          color: ${placeholderColor ?? colors.gray[400]};
        }

        ${getErrorStyles()}
      `;
    default:
      return '';
  }
};